namespace $.$$ {
	export class $shm_hitalama_map_widget_float_notebook_edit extends $.$shm_hitalama_map_widget_float_notebook_edit {
		
		@ $mol_mem_key
		widget_controls( ref: $giper_baza_link ): readonly ( any )[] {
			return [this.Map_page().Widget( ref ).Sub_hack('code').Content_scroll()]
			// return this.Map_page().Widget( ref ).Sub().Content_scroll()
		}
		
	}
}
